import React from 'react'
import { Box, TextField, Typography } from '@applift/factor'
import { Action, PixelInfo } from '../../../models/Pixel'
import { usePixelAdvancedSettingList } from '../../../hooks/usePixel'
import {
  ADVANCED_SETTING_NAME,
  ATTRIBUTION_IDS,
} from '../../../constants/constants'

interface ConversionDurationProps {
  dispatch: React.Dispatch<Action>
  data: PixelInfo
}

export const ConversionDurationSettings = (props: ConversionDurationProps) => {
  const { data, dispatch } = props

  const advancedDurationSettings = usePixelAdvancedSettingList()?.data?.data

  const postClickSetting = advancedDurationSettings?.find(
    item => item.name === ADVANCED_SETTING_NAME.POST_CLICK
  )
  const postViewSetting = advancedDurationSettings?.find(
    item => item.name === ADVANCED_SETTING_NAME.POST_VIEW
  )

  const { attributionId, conversionSetting } = data

  return (
    <>
      <Typography component="h5" variant="bodySmall" weight="demi">
        Conversion Duration Settings
      </Typography>
      <Typography
        sx={{
          textColor: 'neutral-500',
        }}
      >
        Conversion duration settings determine the length of time after a user
        clicks or views an ad that a conversion can be attributed to that ad.
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {postViewSetting && attributionId !== ATTRIBUTION_IDS.CLICK_BASED && (
          <>
            <Typography sx={{ mr: 8 }}>
              {postViewSetting.displayName}: Days
            </Typography>
            <TextField
              variant="outlinedDash"
              size="medium"
              InputProps={{
                numberInput: true,
                NumberInputProps: {
                  allowMouseWheel: true,
                  step: 1,
                  max: 30,
                  min: 1,
                },
              }}
              fullWidth={false}
              sx={{ mr: 8 }}
              value={conversionSetting.conversionDuration.view}
              onChange={e =>
                dispatch({
                  type: 'UPDATE_CONVERSION_DURATION',
                  payload: { view: Number(e.target.value) },
                })
              }
            />
          </>
        )}

        {postClickSetting && attributionId !== ATTRIBUTION_IDS.VIEW_BASED && (
          <>
            <Typography sx={{ mr: 8 }}>
              {postClickSetting.displayName}: Days
            </Typography>

            <TextField
              variant="outlinedDash"
              size="medium"
              InputProps={{
                numberInput: true,
                NumberInputProps: {
                  allowMouseWheel: true,
                  step: 1,
                  max: 60,
                  min: 7,
                },
              }}
              fullWidth={false}
              value={conversionSetting.conversionDuration.click}
              onChange={e =>
                dispatch({
                  type: 'UPDATE_CONVERSION_DURATION',
                  payload: { click: Number(e.target.value) },
                })
              }
            />
          </>
        )}
      </Box>
    </>
  )
}
